import React from 'react';
import { Spinner } from 'react-bootstrap';
import { Trash2 } from 'lucide-react';

const DeleteButton = ({
  productId,
  onDelete,
  isDeleting = false,
  variant = 'icon', // "icon" | "text"
  translate = (key) => key,
  className = '',
}) => {
  const handleDelete = (e) => {
    // جلوگیری از event bubbling
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    if (onDelete && !isDeleting && productId) {
      console.log('Deleting product:', productId); // برای debug
      onDelete(productId);
    }
  };

  if (isDeleting) {
    return (
      <div className={`delete-button-container ${className}`}>
        <Spinner animation='border' size='sm' />
      </div>
    );
  }

  return (
    <div className={`delete-button-container ${className}`}>
      <button onClick={handleDelete} className={`delete-btn ${variant === 'text' ? 'teammate-delete-btn' : ''}`} aria-label='حذف محصول' type='button'>
        {variant === 'icon' ? <Trash2 className='delete-icon' /> : translate('delete')}
      </button>
    </div>
  );
};

export default DeleteButton;
